import { render, staticRenderFns } from "./invoiceBill.vue?vue&type=template&id=0fb1cc16&scoped=true"
import script from "./invoiceBill.vue?vue&type=script&lang=js"
export * from "./invoiceBill.vue?vue&type=script&lang=js"
import style0 from "./invoiceBill.vue?vue&type=style&index=0&id=0fb1cc16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1cc16",
  null
  
)

export default component.exports